<template lang="pug">
  .stock-rank
    .title 相关个股涨跌排行
    .section(v-for="item in list" :key="item.id" @click="jumpStockDetail(item.id)")
      .stock-name {{item.name}} {{item.id}}
      vant-row
        vant-col(:span="8")
          span.theme {{item.count}}
          span 历史发生次数
        vant-col(:span="8")
          span(:class="item.victory | probabilityColorFormat") {{item.victory |  parseValidRatio}}
          span 胜率
        vant-col(:span="8")
          span(:class="item.chg | valueColorFormat") {{item.chg |  parseValidRatio}}
          span 最佳平均涨幅
</template>

<script>
import { Row, Col } from 'vant'
import { parseValidRatio, valueColorFormat, probabilityColorFormat } from '@utils/values'

export default {
  components: {
    VantRow: Row,
    VantCol: Col
  },
  /**
   * [
   *  {
   *    chg: 平均涨幅
   *    count: 查看历史事件N次
   *    id: 票code
   *    name: 个股名称
   *    victory: 上涨概率s
   *  }
   * ]
   *
   */
  props: {
    list: Array
  },
  filters: {
    parseValidRatio,
    valueColorFormat,
    probabilityColorFormat
  },
  methods: {
    jumpStockDetail(id) {
      this.$emit('jumpStockDetail', id)
    }
  }
}
</script>

<style lang="stylus" scoped>
.stock-rank
  .title
    font-size 1.07rem
    font-weight 600
    margin-bottom 1.14rem
  .section
    border 1px solid #f9f9f9
    box-shadow #f9f9f9 0 0 1.07rem
    .van-row
      .van-col
        display flex
        flex-direction column
        >span
          &:first-child
            font-size 1.43rem
            line-height 1.79rem
            margin 1.43rem 0 1rem 0
          &:last-child
            font-size .86rem
            color $light-text-color
</style>
